import * as React from 'react';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import './CustomToolTip.css';

interface StyledTooltipProps extends TooltipProps {
	tooltipText: string | React.ReactNode;
}

const CustomToolTip: React.FC<StyledTooltipProps> = ({ tooltipText, children, placement = 'top', ...props }) => {
	const [open, setOpen] = React.useState(false);
	const tooltipRef = React.useRef<HTMLSpanElement>(null);

	const handleClick = (event: React.MouseEvent) => {
		event.stopPropagation(); // Evita que el click se propague
		setOpen(!open);
	};

	// Cerrar tooltip al hacer click fuera
	React.useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
				setOpen(false);
			}
		};

		if (open) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [open]);

	return (
		<Tooltip
			{...props}
			title={tooltipText}
			open={open}
			onClose={() => setOpen(false)}
			disableHoverListener
			disableFocusListener
			disableTouchListener
			placement={placement}
			classes={{ tooltip: 'custom-tooltip' }}
			PopperProps={{
				style: { zIndex: 900 },
			}}>
			<span
				ref={tooltipRef}
				onClick={handleClick}
				style={{ cursor: 'pointer' }}>
				{children}
			</span>
		</Tooltip>
	);
};

export default CustomToolTip;
